/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Southeast_Asian_Studies26Inputs */

const en__field_enum_study_southeast_asian_studies26 = /** @type {(inputs: _Field_Enum_Study_Southeast_Asian_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages and Cultures of Southeast Asia`)
};

const de__field_enum_study_southeast_asian_studies26 = /** @type {(inputs: _Field_Enum_Study_Southeast_Asian_Studies26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen und Kulturen Südostasiens`)
};

/**
* | output |
* | --- |
* | "Languages and Cultures of Southeast Asia" |
*
* @param {_Field_Enum_Study_Southeast_Asian_Studies26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_southeast_asian_studies26 = /** @type {((inputs?: _Field_Enum_Study_Southeast_Asian_Studies26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Southeast_Asian_Studies26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_southeast_asian_studies26(inputs)
	return de__field_enum_study_southeast_asian_studies26(inputs)
});
export { _field_enum_study_southeast_asian_studies26 as "_field_enum_STUDY_SOUTHEAST_ASIAN_STUDIES" }